<template>
    <Portal to="modal">
        <ModalContainer
            key="weakestConceptsFeedbackModal"
            :is-dark-mode="isDarkMode"
            @close="emitClose"
        >
            <template #modal>
                <Modal
                    :show-close-button="true"
                    class="weakest-concepts-feedback__modal"
                    :is-dark-mode="isDarkMode"
                    @close="emitClose"
                >
                    <div class="weakest-concepts-feedback">
                        <div v-dark class="weakest-concepts-feedback__title">
                            Tell us more! What would make this feature more helpful?
                        </div>
                        <PocketTextarea
                            v-model="feedback"
                            class="weakest-concepts-feedback__field"
                            :is-dark-mode="isDarkMode"
                            :auto-focus="true"
                            height="62px"
                            width="100%"
                        />
                        <div class="weakest-concepts-feedback__buttons">
                            <PocketButton
                                :is-dark-mode="isDarkMode"
                                type="secondary"
                                @click="emitClose"
                            >
                                Cancel
                            </PocketButton>
                            <PocketButton
                                :is-dark-mode="isDarkMode"
                                :disabled="!trimmedFeedback"
                                @click="submit"
                            >
                                Submit
                            </PocketButton>
                        </div>
                    </div>
                </Modal>
            </template>
        </ModalContainer>
    </Portal>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import UIKit from '@pocketprep/ui-kit'
import { userModule } from '@/store/user/module'

const {
    Modal,
    ModalContainer,
    Textarea: PocketTextarea,
    Button: PocketButton,
} = UIKit

const emit = defineEmits<{
    close: []
    submit: [feedback: string]
}>()

const feedback = ref('')

const trimmedFeedback = computed(() => feedback.value.trim())

const isDarkMode = computed(() => userModule.state.settings.isDarkMode)

const emitClose = () => {
    emit('close')
}

const submit = () => {
    if (!trimmedFeedback.value) {
        return
    }

    emit('submit', trimmedFeedback.value)
}
</script>

<style lang="scss" scoped>
.weakest-concepts-feedback {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    width: 520px;
    padding: 24px 32px 32px;
    box-sizing: border-box;

    @include breakpoint(black-bear) {
        width: 100%;
        padding: 36px 16px 24px;
    }

    &__modal {
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
        top: 80px;

        @include breakpoint(black-bear) {
            width: 356px;
            height: auto;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }

    &__title {
        padding: 0 40px;
        font-size: 18px;
        line-height: 25px;
        letter-spacing: 0.3px;
        font-weight: 600;
        text-align: center;
        color: $brand-black;

        @include breakpoint(black-bear) {
            padding: 0 24px;
        }

        &--dark {
            color: $fog;
        }
    }

    &__field {
        width: 100%;

        :deep(.uikit-textarea__textarea) {
            box-sizing: border-box;
        }
    }

    &__buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }
}
</style>
